import React, { useContext } from "react";
import ToBeSignedListTableRowCertification from "pages/toBeSignedList/table/row/certification/ToBeSignedListTableRowCertification";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";

const ToBeSignedListTableRowCertificationContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);

  const certification = entity as CertificationInterface;

  return (
    <ToBeSignedListTableRowCertification
      {...{
        certification,
      }}
    />
  );
};

export default React.memo(ToBeSignedListTableRowCertificationContainer);
